export * from './Footer.model'
export { default as Footer, type FooterProps } from './Footer'
